<template>
  <div
    class="phone"
    ref="phone"
  >
    <a
      type="primary"
      @click="showModal"
    >
      更换手机号
    </a>
    <a-modal
      title="更换手机号绑定"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      cancel-text="取消"
      :ok-text="btnText"
      :get-container="()=>$refs.phone"
    >
      <!-- 验证 -->
      <a-spin
        :spinning="spinPhone"
        v-if="isPhone===1 && phone"
      >
        <div>
          <div
            class="wain"
            style="height: 30px;
          line-height:30px;
          background: #FFFBF3;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #E7B24B;"
          >
            <span><a-icon
              type="info-circle"
              style="margin: 0 10px"
            />若该手机号已无法使用请联系客服</span>
          </div>
          <div
            style="font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333333;
          display: flex;
          margin: 20px 0"
          >
            <span style="width:94px;" />
            已绑定手机号：<span v-if="phone">{{ telephone(phone) }}</span>
          </div>
          <div
            style="display: flex;
          align-items: center;
          margin-bottom: 20px;
          position: relative;"
          >
            <span
              style="width: 80px;
            text-align: right;
            margin-right: 14px;"
            >验证码</span><a-input
              v-model="code"
              placeholder="请输入验证码"
              style="width: 330px;
            height: 40px;
            background: #FFFFFF;
            border: 1px solid #EAEAEA;
            border-radius: 3px;"
            />
            <img
              :src="codeImg"
              @click="getImgcode"
              style="width: 88px;
            height: 26px;
            border-radius: 3px;
            position: absolute;
            right: 55px;
            cursor: pointer;"
            >
          </div>
          <div
            style="display: flex;
          align-items: center;
          margin-bottom: 20px;
          position: relative;"
          >
            <span
              style="width: 80px;
            text-align: right;
            margin-right: 14px;"
            >短信验证码</span><a-input
              v-model="phCode"
              placeholder="请输入短信验证码"
              style="width: 330px;
            height: 40px;
            background: #FFFFFF;
            border: 1px solid #EAEAEA;
            border-radius: 3px;
            padding-right: 90px;"
            />
            <a
              @click="throttle"
              v-if="isTime"
              style="position: absolute;
            right: 55px;"
            >获取验证码</a>
            <span
              v-else
              style="position: absolute;
            right: 55px;
            color: #aaa;"
            >{{ time }}s重新获取</span>
          </div>
        </div>
      </a-spin>
      <!-- 新手机号 -->
      <a-spin
        :spinning="spinPhone"
        v-if="isPhone===2 || !phone"
      >
        <div>
          <div
            style="display: flex;
          align-items: center;
          margin-bottom: 20px;
          position: relative;"
          >
            <span
              style="width: 80px;
            text-align: right;
            margin-right: 14px;"
            >新手机号码</span><a-input
              v-model="newPhone"
              placeholder="请输入新手机号码"
              style="width: 330px;
            height: 40px;
            background: #FFFFFF;
            border: 1px solid #EAEAEA;
            border-radius: 3px;"
            />
          </div>
          <div
            style="display: flex;
          align-items: center;
          margin-bottom: 20px;
          position: relative;"
          >
            <span
              style="width: 80px;
            text-align: right;
            margin-right: 14px;"
            >验证码</span><a-input
              v-model="newCode"
              placeholder="请输入验证码"
              style="width: 330px;
            height: 40px;
            background: #FFFFFF;
            border: 1px solid #EAEAEA;
            border-radius: 3px;"
            />
            <img
              :src="codeImg2"
              @click="getImgcode(2)"
              style="width: 88px;
            height: 26px;
            border-radius: 3px;
            position: absolute;
            right: 55px;
            cursor: pointer;"
            >
          </div>
          <div
            style="display: flex;
          align-items: center;
          margin-bottom: 20px;
          position: relative;"
          >
            <span
              style="width: 80px;
            text-align: right;
            margin-right: 14px;"
            >短信验证码</span><a-input
              v-model="newPhCode"
              placeholder="请输入短信验证码"
              style="width: 330px;
            height: 40px;
            background: #FFFFFF;
            border: 1px solid #EAEAEA;
            border-radius: 3px;
            padding-right: 90px;"
            />
            <a
              v-if="isTime"
              @click="throttle(2)"
              style="position: absolute;
            right: 55px;"
            >获取验证码</a>
            <span
              v-else
              style="position: absolute;
            right: 55px;
            color: #aaa;"
            >{{ time }}s重新获取</span>
          </div>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { telephone } from '@/utils/format.js';
import { graphicsCode, smsCode } from '@/api/code.js';
import { modifyPhoneStepOne, modifyPhoneStepTwo } from '@/api/user/user.js';
export default {
  name: 'PhoneNumber',
  data() {
    return {
      code: '',
      phCode: '',
      newPhone: '',
      newCode: '',
      newPhCode: '',
      codeImg: '',
      codeImg2: '',
      telephone,
      phone: '',
      visible: false, // 弹窗显示
      confirmLoading: false, // 按钮加载
      spinPhone: false, // 加载
      isPhone: 1, // 手机号步骤显示
      isTime: true,
      btnText: '下一步',
      timer: '',
      time: 10,
      lastTime: 0,
    };
  },
  mounted() {
    this.getImgcode();
  },
  methods: {
    /* 图片验证码 */
    getImgcode(n) {
      if (n === 2) {
        graphicsCode({ source: 'MODIFY_PHONE_NUM_NEW' }).then(res => {
          this.codeImg2 = window.URL.createObjectURL(res.data);
        });
      } else {
        graphicsCode({ source: 'MODIFY_PHONE_NUM' }).then(res => {
          this.codeImg = window.URL.createObjectURL(res.data);
        });
      }
    },
    /* 获取验证码 */
    getPhcode(n) {
      this.timer = '';
      if (n === 2) {
        smsCode({ source: 'MODIFY_PHONE_NUM_NEW', checkCode: this.newCode, phoneNum: this.newPhone }).then(res => {
          if (res.data.status === 'FAIL') {
            this.$message.warning(res.data.errorMsg);
          }
          this.isTime = false;
          this.timer = setInterval(this.countDown, 1000);
        });
      } else {
        smsCode({ source: 'MODIFY_PHONE_NUM', checkCode: this.code, phoneNum: this.phone }).then(res => {
          if (res.data.status === 'FAIL') {
            this.$message.warning(res.data.errorMsg);
          } else {
            this.isTime = false;
            this.timer = setInterval(this.countDown, 1000);
          }
        });
      }
    },
    countDown() {
      if (this.time > 0) {
        this.time--;
      } else {
        this.time = 10;
        this.isTime = true;
        clearInterval(this.timer);
      }
    },
    // 节流
    throttle(n) {
      const nowTime = new Date().getTime();
      if (nowTime - this.lastTime > 1000) {
        this.getPhcode(n);
        this.lastTime = nowTime;
      }
    },
    showModal() {
      this.isPhone = 1;
      this.btnText = '下一步';
      this.visible = true;
      if (!this.phone) {
        this.btnText = '确定';
        this.getImgcode(2);
      }
    },
    handleOk(e) {
      if (e.target.innerText === '下一步') {
        this.spinPhone = true;
        this.confirmLoading = true;
        modifyPhoneStepOne({ phoneCode: this.phCode }).then(res => {
          if (res.data.status === 'SUCCESS') {
            this.spinPhone = false;
            this.confirmLoading = false;
            this.isPhone = 2;
            this.btnText = '确定';
            this.getImgcode(2);
          } else {
            this.spinPhone = false;
            this.confirmLoading = false;
            this.$message.warning(res.data.errorMsg);
          }
        });
      } else {
        this.spinPhone = true;
        this.confirmLoading = true;
        modifyPhoneStepTwo({ phoneCode: this.newPhCode, phoneNumNew: this.newPhone }).then(res => {
          const pattern = /^1[3|4|5|7|8][0-9]{9}$/;
          if (!pattern.test(this.newPhone)) {
            this.$message.warning('手机号码错误');
            this.spinPhone = false;
            this.confirmLoading = false;
            return false;
          }
          if (res.data.status === 'SUCCESS') {
            this.visible = false;
            this.spinPhone = false;
            this.confirmLoading = false;
            this.$message.success('新手机号绑定成功！');
            this.$parent.$parent.info();
          } else {
            this.spinPhone = false;
            this.confirmLoading = false;
            this.$message.warning(res.data.errorMsg);
          }
        });
      }
    },
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.phone {
  /deep/ .ant-modal-header {
    border: none;
  }
  /deep/ .ant-modal-footer {
    border: none;
    height: 76px;
    background-color: #F7FAFF;
  }
  /deep/ .ant-modal-body {
    padding: 0 24px;
  }
  /deep/ .ant-spin-container {
    padding-top: 10px;
    border-top: 1px solid #EBF2F7;
  }
  /deep/ .ant-btn {
    width: 100px;
    height: 36px;
    border-radius: 3px;
    border: 1px solid #007CE2;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin-top: 10px;
    color: #007CE2;
  }
  /deep/ .ant-btn-primary {
    background: #007CE2;
    color: #fff;
    margin-right: 14px;
    margin-left: 20px;
  }
}
</style>
